import * as Sentry from '@sentry/angular';

export function reportErrorExternally(err: unknown): void {
  Sentry.captureException(normalizeError(err));
}

function normalizeError(err: unknown): Error {
  if (err instanceof Error) {
    return err;
  }

  if (typeof err === 'string') {
    return new Error(err);
  }

  if (err && typeof err === 'object' && 'message' in err) {
    const message = (err as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim().length > 0) {
      return new Error(message);
    }
  }

  return new Error('Unknown error');
}
